/**
 * Created by claudio iozzia on 04/07/2017.
 */
import {EntityError} from "../../../../models/EntityAlert";
import {Utils} from "../../../../common/utils";
import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";


export class Validator_DcDc_BuckBoost extends Validator_DcDc_Buck {
  private validatorFn_SingleOutput_Voltage_BuckBoost: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;

    const vOutLowerBound: number = ic.vout_min;
    const vOutUpperBound: number = ic.vout_max;

    const result = Utils.acceptInRange(_vOut, vOutLowerBound, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_BuckBoost];
  }
}
